import baseService from '@/utils/comRequest'
export function getmogasubscribetime(query) {
    return baseService({
        url: '/customapi/getmogasubscribetime',
        method: 'get',
        params: query
    })
}
